module.exports = {
	"access_users": {
		"attributes": {
			"code": "Código",
			"id": "Id",
			"name": "Nome",
			"email": "Email",
			"password": "Senha",
			"new_password": "Nova senha",
			"password_confirmation": "Confirmação de senha"
		},
		"main": {
			"title": "Usuários de acesso",
			"list_plans": "Lista de usuários de acesso",
			"buttons": {
				"new": "Incluir usuário"
			}
		},
		"edit": {
			"edit": "Editar"
		},
		"new": {
			"new": "Incluir Usuário"
		},
		"messages": {
			"access_user": "Usuário de acesso",
			"access_users_info": "Inclua os dados de um usuário que terá acesso ao sistema.",
			"changed_with_success": "Usuário de acesso alterado.",
			"created_with_success": "Usuário de acesso criado.",
			"deleted_with_success": "Usuário deletado"
		},
		"modal": {
			"destroy_access_user_description_message": "Ao excluir esse usuário, não será possível recuperá-lo",
			"destroy_access_user": "Excluir Usuário",
			"destroy_access_user_message": "<p>Deseja realmente excluir o usuário <strong>%{accessUser}</strong>?</p>"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/access_users/pt-BR.yml
// module id = 577
// module chunks = 1